// @ts-nocheck
import { initialState } from './reducer';

const paginationSelector = state => state.pagination || initialState;

export const getPaginationFilters = (state: any, tableId: string) => {
  return paginationSelector(state)[tableId];
};
